import { createBrowserHistory } from 'history';
import { set } from '../../globalState/api';
import { HISTORY_INSTANCE, HISTORY_BASE_PATH } from './globalState';

/**
 * Matches a URL path against a pattern. This is a strict subset of the
 * URLPattern standard (https://urlpattern.spec.whatwg.org/).
 *
 * Only two pattern features are supported:
 *   - Literal path segments: `/app/settings`
 *   - Named parameters: `/app/:portalId`
 *
 * Notably NOT supported: wildcards, regex, optional segments, or modifiers.
 */
function matchPattern(pattern, pathname) {
  if (pattern === '/') {
    if (pathname.startsWith('/')) {
      return {
        basePathname: '/',
        params: {}
      };
    }
    return undefined;
  }
  const patternSegments = pattern.split('/');
  const pathSegments = pathname.split('/');
  if (pathSegments.length < patternSegments.length) {
    return undefined;
  }
  const params = {};
  const matchedSegments = [];
  for (let i = 0; i < patternSegments.length; i++) {
    const patternSegment = patternSegments[i];
    const pathSegment = pathSegments[i];
    if (patternSegment.startsWith(':')) {
      const paramName = patternSegment.slice(1);
      if (!paramName) {
        throw new TypeError(`Invalid historyBasename pattern '${pattern}'. Missing parameter name.`);
      }
      if (!pathSegment) {
        return undefined;
      }
      params[paramName] = pathSegment;
      matchedSegments.push(pathSegment);
    } else if (patternSegment === pathSegment) {
      matchedSegments.push(pathSegment);
    } else {
      return undefined;
    }
  }
  return {
    basePathname: matchedSegments.join('/'),
    params
  };
}
export function findBasePath(historyBasename, currentPathname) {
  const basenames = Array.isArray(historyBasename) ? historyBasename : [historyBasename];
  for (const pattern of basenames) {
    const match = matchPattern(pattern, currentPathname);
    if (match) {
      return match;
    }
  }
}
export function initializeHistory(historyBasename) {
  const basePath = findBasePath(historyBasename, window.location.pathname);
  if (!basePath) {
    throw new Error('Browser url does not match `historyBasename`');
  }
  const history = createBrowserHistory({
    basename: basePath.basePathname
  });
  set(HISTORY_INSTANCE, history);
  set(HISTORY_BASE_PATH, basePath);
  return history;
}